(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tft-events"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('tft-event-directory')){
    customElements.define('tft-event-directory',class extends HTMLElement{
      connectedCallback(){
        if(this.dataset.ready)return;
        this.dataset.ready='true';
        const cards=Array.from(this.querySelectorAll('[data-event]')).sort((a,b)=>a.dataset.date.localeCompare(b.dataset.date));
        const grid=this.querySelector('[data-grid]');
        cards.forEach(card=>grid.append(card));
        const search=this.querySelector('[data-search]');
        const state=this.querySelector('[data-state]');
        [...new Set(cards.map(card=>card.dataset.state).filter(Boolean))].sort().forEach(value=>state.add(new Option(value,value)));
        const apply=()=>{
          const term=search.value.trim().toLocaleLowerCase();
          let count=0;
          cards.forEach(card=>{const visible=(!state.value||card.dataset.state===state.value)&&card.dataset.searchText.toLocaleLowerCase().includes(term);card.hidden=!visible;if(visible)count++;});
          this.querySelector('[data-count]').textContent=String(count);
          this.querySelector('[data-empty]').hidden=count>0;
        };
        search.addEventListener('input',apply);
        state.addEventListener('change',apply);
        this.querySelector('[data-reset]').addEventListener('click',()=>{search.value='';state.value='';apply();});
        this.querySelector('[data-filters]').hidden=false;
        this.querySelector('[data-result]').hidden=false;
        apply();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
